import { render, staticRenderFns } from "./TheAddNewGroupModal.vue?vue&type=template&id=52fa10cc&scoped=true"
import script from "./TheAddNewGroupModal.vue?vue&type=script&lang=js"
export * from "./TheAddNewGroupModal.vue?vue&type=script&lang=js"
import style0 from "./TheAddNewGroupModal.vue?vue&type=style&index=0&id=52fa10cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa10cc",
  null
  
)

export default component.exports